
/** 
* This file has been auto-generated by '@kontent-ai/model-generator@8.1.1'.
* 
* (c) Kontent.ai
*  
* -------------------------------------------------------------------------------
* 
* Project: UnumUK Employer Portal
* Environment: Dev (Previously Phase 2)
* Id: a5beabf7-cb3f-0126-9900-a0a631d69346
* 
* -------------------------------------------------------------------------------
**/

import type { Elements } from '@kontent-ai/delivery-sdk';
import type { CoreContentType } from "../system/index.js";

/**
 * 📷 Media // External Video
 *
 * Id: 23b78519-7d51-49f9-8e7f-9d401d46ee55
 * Codename: external_video
 */
export type MediaExternalVideo = CoreContentType<
    MediaExternalVideoElementCodenames,
    {
        /**
         * URL
         *
         * Type: text
         * Required: true
         * Codename: url
         * Id: 84678a0d-7a1a-4f2a-a0d6-d088e136380c
         * Guidelines: Insert a Youtube or Vimeo URL
         */
        readonly url: Elements.TextElement;
    },
    'external_video'
>;

/**
 * Type representing all available element codenames for 📷 Media // External Video
 */
export type MediaExternalVideoElementCodenames = 'url';

/**
 * Type guard for 📷 Media // External Video
 *
 * Id: 23b78519-7d51-49f9-8e7f-9d401d46ee55
 * Codename: external_video
 */
export function isMediaExternalVideo(item: CoreContentType | undefined | null): item is MediaExternalVideo {
    return item?.system?.type === 'external_video';
}
